import { useQueryClient, useMutation } from '@tanstack/react-query';
import { updateTenantDetails } from "../orgPanelApiCalls";
import { key as editTenantKey } from "../queries/useUpdateTenantQuery";
import { updateAccountNameInTenantCollection } from '../appStore';

const useUpdateTenantMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (variables) => {
            const data = await updateTenantDetails({
                TenantAccountId: variables.e.target.id.value,
                DCGOrgId: variables.e.target.dcgId.value,
                CompanyName: variables.e.target.tenantName.value,
                PortalAdminName: variables.e.target.portalAdminName.value,
                PortalAdminEmail: variables.e.target.portalAdminEmail.value,
                Country: variables.e.target.country.value,
                Address1: variables.e.target.address1.value,
                Address2: variables.e.target.address2.value,
                City: variables.e.target.city.value,
                State: variables.e.target.state.value,
                Zip: variables.e.target.zip.value,
                Phone: variables.e.target.phone.value
            });

            return data;
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries([editTenantKey]);
            updateAccountNameInTenantCollection(variables.e.target.id.value, variables.e.target.tenantName.value)
        },
    })
}

export { useUpdateTenantMutation };